"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromoDescription = require("./PromoDescription");
Object.keys(_PromoDescription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromoDescription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromoDescription[key];
    }
  });
});